import type { UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { AppointmentV1 } from "../schemas/appointment_v1";

export const getAppointmentsV1QueryKeyPrefix = "getAppointmentsV1";
type QueryKey = [typeof getAppointmentsV1QueryKeyPrefix, number];
const getAppointmentsV1QueryKey = (therapistID: number): QueryKey => [getAppointmentsV1QueryKeyPrefix, therapistID];

export const useGetAppointmentsV1 = (therapistID: number): UseQueryResult<AppointmentV1[], Error> => {
  const client = useApiClient();

  return useQuery({
    queryKey: getAppointmentsV1QueryKey(therapistID),
    queryFn: () => client.getAppointmentsV1(therapistID),
  });
};
